import { gql } from '@apollo/client';

export const ADMIN_USERS_QUERY = gql`
  query AdminUsers($offset: Int, $limit: Int, $search: String, $status_filter: UserStatusFilter) {
    adminUsers(offset: $offset, limit: $limit, search: $search, status_filter: $status_filter) {
      items {
        id
        email
        full_name
        professional_license
        photo_url
        status
        branch_id
        role_names
        failed_login_attempts
        locked_until
        last_login_at
        created_at
        updated_at
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const USER_ROLE_OPTIONS_QUERY = gql`
  query UserRoleOptions {
    userRoleOptions {
      id
      name
      description
    }
  }
`;

export const CREATE_ADMIN_USER_MUTATION = gql`
  mutation CreateAdminUser($input: CreateAdminUserInput!) {
    createAdminUser(input: $input) {
      id
    }
  }
`;

export const UPDATE_ADMIN_USER_MUTATION = gql`
  mutation UpdateAdminUser($id: ID!, $input: UpdateAdminUserInput!) {
    updateAdminUser(id: $id, input: $input) {
      id
    }
  }
`;

export const SET_ADMIN_USER_STATUS_MUTATION = gql`
  mutation SetAdminUserStatus($id: ID!, $status: UserStatus!) {
    setAdminUserStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const RESET_ADMIN_USER_PASSWORD_MUTATION = gql`
  mutation ResetAdminUserPassword($input: ResetAdminUserPasswordInput!) {
    resetAdminUserPassword(input: $input)
  }
`;

